<template>
  <div class="SidebarOverlay">
    <div class="video-slider running-video">
      <div class="sidebar" :class="{ alignSideBar: page}">
          <ol class="question-box">
            <li>
              <span>Risk Disclosure and Product Suitability</span>
							<ul>
								<li>
                  <a href="#" @click="onSelectTopic">Capital Markets & Derivatives</a>
                </li>
							</ul>
              <span @click="onSelectQuiz" class="star"><i class="fa fa-star"></i>Quiz</span>
            </li>
          </ol>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SidebarOverlay',

  props: {
    page: {
      type: String,
    },
  },
  methods: {
    onSelectQuiz() {
      this.$router.push('/quiz');
      window.fbq('track', 'RDD_QuizPageVisit');
    },
    onSelectTopic() {
      // this.$router.push('/home');
      this.$emit('selectTopic');
    },
  },
};
</script>

<style lang="scss" scoped>
.SidebarOverlay {
  background: rgba(22, 27, 37, 0.62) none repeat 0 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 90%;
  z-index: 0;

  .video-slider .running-video {
    margin-bottom: 70px;
    position: relative;
  }
  .sidebar {
    background: rgba(0, 0, 0, 0)
      linear-gradient(
        27deg,
        rgba(104, 184, 250, 0.93),
        rgba(99, 182, 250, 0.93),
        rgba(6, 124, 241, 0.93)
      )
    repeat 0 0;
    height: 600px;
    left: 0;
    overflow-x: hidden;
    position: absolute;
    top: 67px;
    width: 310px;
  }
  .alignSideBar {
    height: 100vh;
    position: relative;
    top: 0px;
  }

  ol.question-box {
    width: 100%;
    margin: 50px 0 0;
    padding: 0 20px;
    font-family: "Roboto", sans-serif;
  }
  ol.question-box > li {
    color: #ffffff;
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0.5px;
    margin: 0 0 30px;
    list-style-type: decimal;
    list-style-position: inside;
  }
  .question-box span {
    display: inline-block;
    padding: 0 0 0 7px;
    vertical-align: top;
    width: 240px;
    font-weight: 400;
    letter-spacing: 0.5px;
  }
  .question-box ul .completed {
    position: absolute;
    height: 100%;
    width: 1px;
    border-left: 1px solid #c8e2f7;
    margin-left: -17px;
    top: 29px;
  }
  ol.question-box li ul li:hover {
    background: rgba(255, 255, 255, 0.3) none repeat scroll 0 0;
  }
  ol.question-box span.star:hover {
    margin-left: -20px;
    padding-left: 47px;
    width: 100vw;
    background: rgba(255, 255, 255, 0.3) none repeat scroll 0 0;
  }
  .question-box ul li {
    font-size: 15px;
    margin: 0 -25px 0 -25px;
    font-weight: 400;
    padding: 0 0 0 50px;
    position: relative;
    z-index: 2;
    list-style: none;
  }
  .question-box ul li a {
    color: #ffffff;
    display: block;
    font-weight: 200;
    font-family: "Roboto", sans-serif;
    padding: 10px;
    text-decoration: none;
  }
  .question-box ul li a::after {
    background: rgba(104, 184, 250, 0.93) none repeat scroll 0 0;
    border: 1px solid #ffffff;
    border-radius: 100%;
    content: "";
    height: 8px;
    left: 30px;
    position: absolute;
    top: 24px;
    width: 8px;
  }
 
  .question-box span.star {
    cursor: pointer;
    display: block;
    font-size: 15px;
    padding: 12px 27px 0;
    height: 40px;
    font-weight: 200;
    opacity: 0.7;
  }
  .question-box span.star i {
    padding: 0 17px 0 0;
    margin-left: -25px;
  }
  .question-box .visited ul,
  .question-box .visited span.star {
    opacity: 1;
  }
  .question-box .visited ul li a::after {
    background: #ffffff none repeat scroll 0 0;
  }
  .question-box ul li.active {
    background: #77B4ED;
  }
}
</style>


// WEBPACK FOOTER //
// src/modules/Home/components/SidebarOverlay.vue